import { SelectMultiple } from '../controls/SelectMultiple';

export default function SelectMultipleField({
  input: { value, onChange, ...input },
  ...props
}) {
  return <SelectMultiple {...props} value={value} onChange={onChange} />;
}
